import axios from "axios";
import LocalStorage from "../localStorage";
import {loggedOut} from "./auth";

export const GET_TARGET_REQUEST = 'GET_TARGET_REQUEST';
export const GET_TARGET_SUCCESS = 'GET_TARGET_SUCCESS';
export const GET_TARGET_FAILURE = 'GET_TARGET_FAILURE';

const localStorageService = LocalStorage.getService();

export const getTargetRequest = () => {
    return {type: GET_TARGET_REQUEST}
};

export const getTargetSuccess = (target = {}) => {
    return {type: GET_TARGET_SUCCESS, target}
};

export const getTargetFailure = (error) => {
    return {type: GET_TARGET_FAILURE, error}
};

export const startGetTarget = () => {
    console.log('Start startGetTarget');
    let token = localStorageService.getAccessToken();
    return (dispatch) => {
        dispatch(getTargetRequest());
        return axios({
                url: `${process.env.REACT_APP_API_ROOTURL}/target/list?key=${process.env.REACT_APP_SERVICE_ACCOUNT_KEY}`,
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    Authorization: 'Bearer ' + token,
                },
                data: JSON.stringify({}),
            }
        )
            .then(function (response) {
                if (response.status === 200 && response.data !== null) {
                    console.log("Response target search ", response.data);
                    dispatch(getTargetSuccess(response.data));

                }
            })
            .catch(function (error) {
                console.log(error);
                if(error.response.status === 401) dispatch(loggedOut());
                dispatch(getTargetFailure(error));
            });
    };
};
